const methods = {
  getRows(rows, keyObject = 'lot') {
    let index = 0;
    const toSearch = Object.entries(rows).map((row) => {
      const response = {
        name: row[1][keyObject].name,
        index: index,
        /* numberLot: row[1].lot.number_lot, */
        ...row[1],
      };
      index++;
      return response;
    });

    return toSearch;
  },

  totalRegister(rows, keyObject = 'lot') {
    if (this.searchQuery === '') {
      this.pagination.total = this.getRows(rows, keyObject).length;
    }
    return this.pagination.total;
  },

  toRows(rows, keyObject = 'lot') {
    let highBound = this.from + this.pagination.perPage;
    const total = this.totalRegister(rows, keyObject);
    if (total < highBound) {
      highBound = total;
    }
    return highBound;
  },

  queriedDataRows(rows, keyObject = 'lot') {
    let result = this.getRows(rows, keyObject);
    if (this.searchQuery !== '') {
      result = this.fuseSearch.search('=' + this.searchQuery + '');
    }
    this.pagination.total = result.length;
    return result.slice(this.from, this.toRows(rows, keyObject));
  },
};

export default { methods };
